export const DATE_FORMAT: string = 'YYYY-MM-DD';
export const DISPLAY_DATE_FORMAT: string = 'l';
export const DISPLAY_DATE_TIME_FORMAT: string = `${DISPLAY_DATE_FORMAT} LT`;

const emptyDateString = '-';

/**
 * Returns a date object with an offset calculated to negate the current timezone.
 * @returns Date object.
 */
export const parseDate = (dateObject: any): Date => {
  if (dateObject instanceof Date) {
    return dateObject;
  }
  if (typeof dateObject === 'string') {
    const jsDate = new Date(dateObject);
    return new Date(jsDate.getTime() + jsDate.getTimezoneOffset() * 60000);
  }
  return new Date(dateObject);
};

/**
 * Returns a presentational date string, including default presentation for invalid or undefined dates.
 * @returns string
 */
export const getFormattedDate = (dateObject: any): string => {
  if (dateObject) {
    const parsedDate = parseDate(dateObject);
    const options: Intl.DateTimeFormatOptions = { day: 'numeric', month: 'numeric', year: 'numeric' };

    return parsedDate.toLocaleString(navigator.language, options);
  }
  return emptyDateString;
};

const isDateType = (obj: any): obj is Date => {
  return obj instanceof Date;
}
export const getFormattedUtcDate = (date: Date): string => {
  if (isDateType(date)) {
    const options: Intl.DateTimeFormatOptions = { day: 'numeric', month: 'numeric', year: 'numeric', timeZone: 'UTC' };
    return date.toLocaleString(navigator.language, options);
  }

  return emptyDateString;
}

export const getLocaleDatePlaceholderText = (): string => {
  return 'mm/dd/yyyy'; // TODO: figure out a way to display in local format
};

export const getFormattedLocalDateTime = (dateTime: any): string => {
  if (dateTime) {
    const localDateTime = new Date(dateTime).toLocaleString(navigator.language, { hour12: true });
    return localDateTime;
  }

  return emptyDateString;
};

/**
 * getFormControlDate - Use this if you need a date object/string for use with <input /> or other date-field related things.
 * @param date any
 */
export const getFormControlDate = (date: any): string => {
  if (date) {
    const parsedDate = parseDate(date);
    const month = `0${parsedDate.getMonth() + 1}`.slice(-2);
    return `${parsedDate.getFullYear()}-${month}-${parsedDate.getDate()}`;
  }
  return '';
};
